import { render, staticRenderFns } from "./WBUDTextCell.vue?vue&type=template&id=29afc989&"
import script from "./WBUDTextCell.vue?vue&type=script&lang=js&"
export * from "./WBUDTextCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports